import { SET_LANGUAGE } from '../constants/langConstants'

const stored = localStorage.getItem('fc_lang') || 'en'

export const langReducer = (state = { lang: stored }, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      localStorage.setItem('fc_lang', action.payload)
      return { lang: action.payload }
    default:
      return state
  }
}
